import { RouteConfig } from 'vue-router'

const MoreApp = () => import('../views/MoreApp.vue')
export const moreAppRoute: RouteConfig = {
  path: '/more-app',
  name: 'more_app',
  component: MoreApp,
  meta: {
    title: '更多应用',
  },
}

export default [moreAppRoute]
